enum ServerState {
    ready = "eRead",
    loading = "eLoading",
    error = "eError"
}


export default ServerState